// The order matters here. the first entry is used as a fallback.
// Currently the fallback language is Finnish, because many S group services
// are available only in Finnish.
const validLanguages = ['fi', 'sv', 'en'];

export { validLanguages };
//# sourceMappingURL=constants.js.map
